import { PrintMap } from "@esdm/map/dist/map/tools/PrintMap";
import { IPrintOptions } from "@esdm/map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "@esdm/map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "@esdm/map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "@esdm/map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "@esdm/map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "@esdm/map/dist/map/store/MapViewStore";
import { MapContextMenu } from "@esdm/map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "@esdm/map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { LayerGroupFactory } from "@esdm/map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "@esdm/map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "@esdm/map/dist/map/filters/MapFilters";
import { MapPopup, MapPopupOptions } from "@esdm/map/dist/map/MapPopup";
import { IMappingTextPack } from "@esdm/map/dist/resources/MappingTextPack";
import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { ColchesterRecordType, ColchesterRecordSubType } from "./ColchesterRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPackLoader, TextPacks } from "./TextPackLoader";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger
} from "@esdm/map";

import { FeatureAddSmallGeomsAsPoint } from "@esdm/map/dist/layers/vector/sources/loaders";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "@esdm/map/dist/baselayers/interfaces/IBaseLayerFactory";
import { ColchesterHerBoundary } from "./ColchesterHerBoundary";
import { FilterType } from "@esdm/map/dist/map/filters/FilterType";
import { VectorLayerStrategy } from "@esdm/map/dist/layers/vector/VectorLayerStrategy";
import { ZoomToDataBounds } from "@esdm/map/dist/layers/vector/ZoomToDataBounds";
import { MousePosition } from "@esdm/map/dist/map/controls/MousePosition";
import { MapBase } from "./MapBase";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { IlayerGroupCollectionConfig } from "@esdm/map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "@esdm/map/dist/layers/groups/LayerGroupCollections";

import "../wwwroot/css/ol.css";
import "../wwwroot/css/bootstrap-select.css"
import "../wwwroot/css/ol-contextmenu.css";

import { WfsBboxAsWktRequestParams, WfsParamSourceMapServer } from "@esdm/map/dist/layers/vector/sources/wfs";
import { CustomClient_BaseLayerFactory_3857 } from "./customTypings/CustomClient_BaseLayerFactory_3857";

$(function () { 
    let printOptions: PrintMap = new PrintMap();
    let ele = $("#theMap");
    if (ele.length === 1) {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let maxFeatureCount: number = <number>ele.data("max-feature-count");
            let mapData = $("#SingleRecordMapData");
            let recordType: string = mapData.data("record-type");

            let init = function (textpacks: TextPacks) {
                let map: MapSingleRecord = new MapSingleRecord("theMap", recordType, null, maxFeatureCount, printOptions, textpacks.mapping, user);
            }
            TextPackLoader.load().then(init);
        });
    }
});


export class MapSingleRecord extends MapBase {

    private map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private initialised: boolean = false;
    private loadingCount = 0;
    private mfOptions: MapOptions;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;
    private infoPopup: MapPopup;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;  
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mousePosition: MousePosition;

    constructor(
        private _mapElementId: string,     
        private _recordType: string,
        private _recordSubType: string,
        private _maxRecordCount: number,
        public printOptions: IPrintOptions,
        public mappingTextPack: IMappingTextPack,
        user: HbsmrUser) {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }

        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
        this.baseLayerFactory = new CustomClient_BaseLayerFactory_3857();       
        this.featureLoader = new GeoJsonFeatureLoader();
        this.featureAdd = new FeatureAddSmallGeomsAsPoint();
        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.styleFactory = new HbsmrStyleFactory();       
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "SingleRecordMap");                       
        this.mfOptions.mapZoom = 16;       

        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;

        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        //clear the store so we don't remember the layers etc?
        this.mapStore.clear();
        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);        
        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);

        this.herMask = new ColchesterHerBoundary();
        this.map.olMap.addLayer(this.herMask.getMask());

        this.infoPopup = new MapPopup(this.map, this.resourcefactory.getRecordTypeResource(), new ToolTipProvider(), new MapPopupOptions(15));
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, null, {
            showList: false,
            showOpenPanelByDefault: !this.printOptions.isPrintMap,
            rememberActivePanel: true
        });

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);
        } 
        this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);  

        //hide the gazetteer, temp fix possibly pending redoing of the html
        $("#slide-panel-btn-search").hide();
            
        this.initialised = true;
    }



    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let url: string = "/api/MapServer/Hbsmr";

        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            //THE SELECTED RECORD           
            {
                ref: "SelectedRecord",
                displayName: "Selected record",
                type: this._recordType,
                subType: this._recordSubType,
                strategy: VectorLayerStrategy.OgcFilterAll,
                zoomToDataBounds: ZoomToDataBounds.Always,
                useSelectedStyle: true,
                visibleOnLoad: true,
                wfsParams: new WfsParamSourceMapServer(new WfsBboxAsWktRequestParams(), { srsName: "EPSG:27700" }),
                displayInLayerSwitcher: true,
                url: url,
                legend: { polygon: false, line: false },
                restrictMapExtentToDataBounds: true,
                filterOptions: {
                    filterType: FilterType.Ogc,
                    filters: ["Uid"],
                },
                layers: [
                    {
                        layerName: `${this.getLayerNameFromType()}PolygonsWFS`,
                        minZoom: 7,
                        maxZoom: 19
                    }
                    ,
                    {
                        layerName: `${this.getLayerNameFromType()}LinesWFS`,
                        minZoom: 7,
                        maxZoom: 19
                    },
                    {
                        layerName: `${this.getLayerNameFromType()}PointsWFS`,
                        minZoom: 7,
                        maxZoom: 19
                    },
                ]
            },
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Monument, null, { visibleOnFirstLoad: false }),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Event),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ListedBuilding),            
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ConservationArea),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.RegisteredParksAndGardens),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.LocalList)

        ];
        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }   


    public getLayerNameFromType = (): string => {
        let name: string = null;
        let recordType = this._recordType;
        let recordSubType = this._recordSubType;

        switch (recordType) {
            case ColchesterRecordType.Monument:
                name = "Monument"
                break;

            case ColchesterRecordType.Event:
                name = "Event"
                break;

            case ColchesterRecordType.Designation:
                name = "Designation"
                break;
        }


        if (name === null && recordSubType !== null) {
            switch (recordSubType) {
                case ColchesterRecordSubType.ConservationArea:
                    name = "Conservation";
                    break;

                case ColchesterRecordSubType.ListedBuilding:
                    name = "ListedBuilding";
                    break;

                case ColchesterRecordSubType.ScheduledMonument:
                    name = "ScheduledMonument";
                    break;

                case ColchesterRecordSubType.RegisteredParksAndGardens:
                    name = "RegisteredParksAndGardens";
                    break;
                              
                case ColchesterRecordSubType.LocalList:
                    name = "LocalList";
                    break;
            }
        }
        return name;
    }
}

